var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group-list',{attrs:{"groups":_vm.serverGroups},on:{"add":_vm.addServerGroup,"remove":_vm.removeServerGroup,"edit":_vm.editServerGroup,"copy":_vm.copyServerGroup}})}
var staticRenderFns = []

export { render, staticRenderFns }